<aside class="sidebar">
  <div class="sidebar-header">
    <div class="logo-container">
      <div class="logo-icon"></div>
      <div class="logo-text">Trichology CRM</div>
    </div>
  </div>

  <nav class="nav-menu">
    @for (item of navItems(); track item.route) {
      @if (item.children?.length) {
        <div class="nav-group" [class.nav-group--expanded]="expandedSectionRoute() === item.route">
          <div class="nav-item nav-item--parent">
            <a
              class="nav-item__link"
              [routerLink]="item.route"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: false }"
            >
              <mat-icon class="nav-icon">{{ item.icon }}</mat-icon>
              <span class="nav-label">{{ item.label | translate }}</span>
            </a>
            <button
              type="button"
              class="nav-expand"
              [attr.aria-expanded]="expandedSectionRoute() === item.route"
              [attr.aria-label]="'Rozwiń: ' + item.label"
              (click)="toggleSubmenu(item.route, $event)"
            >
              <mat-icon class="nav-expand-icon">expand_more</mat-icon>
            </button>
          </div>
          @if (expandedSectionRoute() === item.route) {
            <ul class="nav-submenu" role="list">
              @for (child of item.children; track child.route) {
                <li class="nav-submenu__item" role="listitem">
                  <a
                    class="nav-item nav-item--sub"
                    [routerLink]="child.route"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }"
                  >
                    @if (child.icon) {
                      <mat-icon class="nav-icon">{{ child.icon }}</mat-icon>
                    }
                    <span class="nav-label">{{ child.label | translate }}</span>
                  </a>
                </li>
              }
            </ul>
          }
        </div>
      } @else {
        <a
          class="nav-item"
          [routerLink]="item.route"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <mat-icon class="nav-icon">{{ item.icon }}</mat-icon>
          <span class="nav-label">{{ item.label | translate }}</span>
        </a>
      }
    }
  </nav>

  <div class="sidebar-bottom">
    <a class="support-link">
      <mat-icon class="nav-icon">help_outline</mat-icon>
      <span class="nav-label">Support</span>
    </a>
  </div>
</aside>
